import { Rights, Roles } from '../graphql/types';

const rolesList = [
  {
    key: Roles.SuperAdmin,
    name: 'Super Admin',
    color: 'error',
    visible: [Rights.CreateAdminUser]
  },
  {
    key: Roles.IsoManager,
    name: 'ISO Manager',
    color: 'primary',
    visible: [Rights.CreateIsoManagerUser]
  },
  {
    key: Roles.Broker,
    name: 'Broker',
    color: 'warning',
    visible: [Rights.CreateBrokerUser]
  },
  {
    key: Roles.Merchant,
    name: 'Merchant',
    color: 'info',
    visible: [Rights.CreateMerchantUser]
  },
  {
    key: Roles.Investor,
    name: 'Investor',
    color: 'success',
    visible: [Rights.CreateInvestorUser]
  },
  {
    key: Roles.Funder,
    name: 'Funder',
    color: 'success',
    visible: [Rights.CreateFunderUser]
  },
  {
    key: Roles.User,
    name: 'User',
    color: 'success',
    visible: [Rights.CreateGuestUser]
  },
  {
    key: Roles.Legal,
    name: 'Legal',
    color: 'success',
    visible: [Rights.CreateLegalUser]
  },
  {
    key: Roles.Collections,
    name: 'Collections',
    color: 'success',
    visible: [Rights.CreateLegalUser]
  },
  {
    key: Roles.Submission,
    name: 'Submission',
    color: 'info',
    visible: [Rights.MenageSubmissionTeam]
  },
  {
    key: Roles.SubmissionAdmin,
    name: 'Submission Admin',
    color: 'info',
    visible: [Rights.CreateAdminUser]
  },
  {
    key: Roles.PreUnderwriter,
    name: 'PreUnderwriter',
    color: 'info',
    visible: [Rights.CreateAdminUser]
  },
  {
    key: Roles.Underwriter,
    name: 'Underwriter',
    color: 'info',
    visible: [Rights.CreateAdminUser]
  }
];

const roleColor = (role: Roles): 'default' | 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning' => {
  return rolesList.filter((row) => row.key === role)[0]?.color as
    | 'default'
    | 'primary'
    | 'secondary'
    | 'error'
    | 'info'
    | 'success'
    | 'warning';
};

const roleList = (rights: Rights[]) => {
  return rolesList.filter((row) => row.visible.filter((x) => rights.includes(x)).length);
};

export { roleColor, roleList };
